module.exports = __webpack_public_path__ + "static/media/logo.22771c0b.png";